import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/login/Login';
import HomePage from './pages/home/Home';
import CardsBoard from './pages/cards/CardsBoard';
import CardsLayout from './pages/cards/CardsLayout';
import CardsAdd from './pages/cards/CardsAdd';
import CardsManagement from './pages/cards/CardsManagement';
import ConfirmUserPage from './pages/confirmUser/ConfirmUser';
import './App.css'

const App = () => {
    const isAuthenticated = () => {
        const accessToken = sessionStorage.getItem('accessToken');
        return !!accessToken;
    };

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={isAuthenticated() ? <Navigate replace to="/home" /> : <Navigate replace to="/login" />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/confirm" element={<ConfirmUserPage />} />
                <Route path="/home" element={isAuthenticated() ? <HomePage /> : <Navigate replace to="/login" />} />
                <Route path="/cards/board" element={<CardsBoard />} />
                <Route path="cards" element={<CardsLayout />}>
                    <Route path="add" element={<CardsAdd />} />
                    <Route path="manage" element={<CardsManagement />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;